import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Design
import { BootstrapModule } from './bootstrap/bootstrap.module';
import { MaterialModule } from './material/material.module';
import { PrimeNgModule } from './prime-ng/prime-ng.module';

// FontAwesome
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';


@NgModule({

    declarations: [

    ],

    imports: [

        CommonModule,
        RouterModule,
        FormsModule,
        BootstrapModule,
        MaterialModule,
        PrimeNgModule,
        FontAwesomeModule

    ],

    exports: [

        RouterModule,
        FormsModule,
        BootstrapModule,
        MaterialModule,
        PrimeNgModule,
        FontAwesomeModule

    ]

})
export class DesignModule {
    constructor (library: FaIconLibrary) {
        library.addIconPacks(fab, far, fas);
    }
}
